module.exports = "/assets/data/12b64d25eda39986741390e8c26f8bc1-NR9.data.json";